import React, { useContext } from "react";
import environment from "../../../../../RelayEnvironment";
import { commitMutation, graphql, QueryRenderer } from "react-relay";
import ItemSelection from "../ItemSelection";
import { GreenMachineContext } from "../GreenMachineContext";
import SlateDisplay from "../SlateDisplay";
import relayEnvironment from "../../../../../RelayEnvironment";
import { GET_GM_SESSION } from "./mutations/GetOrCreateGreenMachineSession";
import "./SelectSlate.css";

const GET_SLATES = graphql`
  query SelectSlateQuery($sportId: ID!, $gameTypeId: ID!) {
    slatesForSportAndGameType(sportId: $sportId, gameTypeId: $gameTypeId) {
      id
      prettyStartTime
      suffix
      gameType {
        id
        name
        isCptMode
      }
      slatecompetitionSet {
        edges {
          node {
            competition {
              id
              homeTeam {
                id
                abbreviation
                name
              }
              awayTeam {
                id
                abbreviation
                name
              }
              name
            }
          }
        }
      }
    }
  }
`;

export default function SelectSlate() {
  const {
    selectedSportID,
    selectedGameTypeID,

    setSelectedSlateID,
    currentStage,
    updateCurrentStage,
    jumpToStage,

    setIsCptMode,
    STAGE_NUMBERS,

    initializeGreenMachineSession,
  } = useContext(GreenMachineContext);

  const STAGE_NUMBER = STAGE_NUMBERS.selectSlate;

  function handleSlateSelect(e, slate) {
    e.preventDefault();

    setSelectedSlateID(slate.id);
    setIsCptMode(slate.gameType.isCptMode);

    commitMutation(relayEnvironment, {
      mutation: GET_GM_SESSION,
      variables: {
        input: {
          slateId: slate.id,
        },
      },
      onCompleted: (content, errors) => {
        if (!errors) {
          if (
            content.getOrCreateGreenMachineSessions.greenMachineSessions
              .length === 1
          ) {
            const greenMachineSession =
              content.getOrCreateGreenMachineSessions.greenMachineSessions[0];

            initializeGreenMachineSession(greenMachineSession);

            jumpToStage(STAGE_NUMBERS.lineupConfiguration);
          } else {
            updateCurrentStage();
          }
        }
      },
      onError: (error) => {},
    });
  }

  if (currentStage < STAGE_NUMBER) {
    return null;
  }

  return (
    <QueryRenderer
      environment={environment}
      query={GET_SLATES}
      variables={{
        sportId: selectedSportID,
        gameTypeId: selectedGameTypeID,
      }}
      render={({ error, props }) => {
        if (error) {
          return <div>Something went wrong.</div>;
        }

        if (!props) {
          return <></>;
        }

        return (
          <div className="gm-select-slate-container">
            <SlateDisplay
              slates={props.slatesForSportAndGameType}
              onClick={handleSlateSelect}
            />
          </div>
        );
      }}
    />
  );
}
